import React, { useState } from 'react'
import Colors from '../colors'
import Button from '../components/Button'
import ButtonOutline from '../components/ButtonOutline'
import ErrorModal from '../components/modals/ErrorModal';
import { createNewDocInDb } from '../firebase';
import { Check } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const containerStyles = {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '20px',
    alignItems: 'center'
}

const styles404 = {
    fontSize: 'max(8vw, 80px)',
    fontWeight: 'bold',
    color: Colors.green
}

const container404styles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 'max(2vw, 10px)',
    marginRight: '7px'
}

const headingContainerStyles = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: '90%',
    marginTop: '15px',
    marginBottom: '25px'
}


const headingStyles = {
    fontSize: '40px',
    fontWeight: 'bold',
    color: Colors.mediumGray,
}

const subheadingStyles = {
    fontSize: '20px',
    marginBottom: '20px'
}

const submittedMsgContainerStyles = {
    fontSize: '20px',
    color: Colors.green,
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    marginBottom: '15px',
}


function ErrorPage() {
    const [errorModalIsVisible, setErrorModalIsVisible] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = (text) => {
        createNewDocInDb('Errors', { description: text })
        setErrorModalIsVisible(false);
        setSubmitted(true);
    }

    return (
        <div style={containerStyles}>
            <div style={container404styles}>
                <span style={styles404}>Oops.</span>
            </div>
            <div style={headingContainerStyles}>
                <span style={headingStyles}>Something went wrong.</span>
                <span style={subheadingStyles}>Please try again.</span>
            </div>
            {!submitted ?
                <Button onClick={() => setErrorModalIsVisible(true)} color={Colors.green}>Report Recurring Issue</Button>
                :
                <div style={submittedMsgContainerStyles}>
                    <span>Thank you for your feedback!</span>
                    <Check sx={{ color: Colors.green }} />
                </div>
            }
            <div style={{ height: 12 }} />
            <ButtonOutline onClick={() => navigate('/')} color={Colors.green}>Return to Dashboard</ButtonOutline>
            <ErrorModal isVisible={errorModalIsVisible} setIsVisible={setErrorModalIsVisible} dataCallback={handleSubmit} />
        </div>
    )
}

export default ErrorPage;